"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _orgGroup = require("@/api/auth/orgGroup");
var _org = require("@/api/auth/org");
var _addr = _interopRequireDefault(require("@/utils/addr"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

Promise.resolve().then(function () {
  return _interopRequireWildcard(require('@/styles/sw_form.scss'));
});
// 水波纹指令
//获取组织组信息
//组织
var _default = exports.default = {
  name: 'addOrEditOrgDialog',
  //添加 或 编辑组织信息
  directives: {
    waves: _waves.default
  },
  props: ["addOrEditData"],
  data: function data() {
    return {
      pcdDataList: null,
      pList: null,
      cList: null,
      dList: null,
      org: {
        orgId: null,
        orgCode: null,
        orgName: null,
        username: null,
        password: null,
        orgGroupId: null,
        addr: null
      },
      addr: {
        provId: null,
        cityId: null,
        dictId: null,
        address: null
      },
      textMap: {
        // 添加
        "create": this.$t('buttons.add'),
        // 更新
        "update": this.$t('buttons.update')
      },
      orgGroupList: null,
      rules: {
        // 请填写名称
        orgName: [{
          required: true,
          message: this.$t('placeholder.PleaseFillName'),
          trigger: 'change'
        }],
        // 请填写标识
        orgCode: [{
          required: true,
          message: this.$t('placeholder.PleaseFillIdent'),
          trigger: 'change'
        }],
        // 请填写用户名
        username: [{
          required: true,
          message: this.$t('placeholder.PleaseFillUsername'),
          trigger: 'change'
        }],
        // 请填写密码
        password: [{
          required: true,
          message: this.$t('placeholder.PleaseFillPassword'),
          trigger: 'change',
          min: 6
        }]
      }
    };
  },
  created: function created() {
    var _this = this;
    (0, _addr.default)(0).then(function (response) {
      if (response) {
        var country = response[0];
        if (country) {
          var countryId = country.id;
          (0, _addr.default)(countryId).then(function (res) {
            _this.pList = res;
          });
        }
      }
    });
  },
  watch: {},
  methods: {
    selectProv: function selectProv(provId, selectCityId) {
      var _this2 = this;
      this.addr.cityId = null;
      this.addr.dictId = null;
      (0, _addr.default)(provId).then(function (response) {
        _this2.cList = response;
        _this2.addr.cityId = selectCityId;
      });
    },
    selectCity: function selectCity(cityId, selectDictId) {
      var _this3 = this;
      this.addr.dictId = null;
      (0, _addr.default)(cityId).then(function (response) {
        _this3.dList = response;
        _this3.addr.dictId = selectDictId;
      });
    },
    selectDict: function selectDict() {
      this.$forceUpdate();
    },
    initData: function initData() {
      var _this4 = this;
      //对整个表单进行重置，将所有字段值重置为初始值并移除校验结果
      this.$nextTick(function () {
        _this4.org.orgId = null;
        _this4.org.orgCode = null;
        _this4.org.orgName = null;
        _this4.org.username = null;
        _this4.org.password = null;
        _this4.org.orgGroupId = null;
        _this4.org.addr = null;
        _this4.addr.provId = null;
        _this4.addr.cityId = null;
        _this4.addr.dictId = null;
      });
      (0, _orgGroup.queryOrgGroupALL)().then(function (response) {
        _this4.orgGroupList = response.data.records;
      });
      if (this.addOrEditData.orgId != null) {
        this.queryOrgEntity();
      }
    },
    queryOrgEntity: function queryOrgEntity() {
      var _this5 = this;
      (0, _org.getOrgById)(this.addOrEditData.orgId).then(function (response) {
        _this5.org = Object.assign({}, response.data); // copy obj
        if (response.extra && response.extra.addr != null) {
          var addrData = response.extra.addr;
          //省份
          _this5.addr.provId = addrData.provId;
          if (addrData.provId != null) {
            _this5.cList = addrData.cityList;
          }
          //城市
          _this5.addr.cityId = addrData.cityId;
          if (addrData.cityId != null) {
            _this5.dList = addrData.dictList;
          }
          //区域
          _this5.addr.dictId = addrData.dictId;
          //地址
          _this5.addr.address = addrData.address;
        }
      });
    },
    createData: function createData() {
      var _this6 = this;
      //保存组织
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this6.org.addr = _this6.addr;
          (0, _org.createOrg)(_this6.org).then(function () {
            // 成功  创建成功
            _this6.$notify({
              title: _this6.$t('prompts.success'),
              message: _this6.$t('prompts.CreatedSucc'),
              type: 'success',
              duration: 3000
            });
            //重新加载 -- 调用父节点
            _this6.$emit("refreshTable");
          }, function (error) {});
        }
      });
    },
    updateData: function updateData() {
      var _this7 = this;
      //提交更新
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this7.org.addr = _this7.addr;
          (0, _org.updateOrg)(_this7.org).then(function () {
            // 成功  更新成功
            _this7.$notify({
              title: _this7.$t('prompts.success'),
              message: _this7.$t('prompts.SuccUpdate'),
              type: 'success',
              duration: 3000
            });
            //重新加载 -- 调用父节点
            _this7.$emit("refreshTable");
          });
        }
      });
    }
  }
};